import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';

import './HowItWorksSection.css';

class HowItWorksSection extends PureComponent {
  render() {
    const { t } = this.props;

    return (
      <div className="section home-how-it-works-section">
        <Grid>
          <h2>{t('How it works?')}</h2>

          <ul className="home-how-it-works-steps-list">
            <li>
              <h3>{t('Find the right bike')}</h3>
              <p>{t('Compare prices, terms of rental and locations of companies. Don\'t waste your time on search - all rental companies of the world are already on BikesBooking.com!')}</p>
            </li>

            <li>
              <h3>{t('Book it online')}</h3>
              <p>{t('We have contracts with all our partners and we offer you special prices. Our prices are always equal or even lower than you will find on arrival.')}</p>
            </li>

            <li>
              <h3>{t('Receive your bike on arrival')}</h3>
              <p>{t('We will notify provider about your reservation and exactly the same bike will wait for you on arrival. Come and just enjoy your ride!')}</p>
            </li>
          </ul>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(HowItWorksSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/HowItWorksSection/HowItWorksSection.js